import { render, staticRenderFns } from "./ArchiveUploaderModal.vue?vue&type=template&id=32b8eb32&scoped=true&"
import script from "./ArchiveUploaderModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveUploaderModal.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveUploaderModal.vue?vue&type=style&index=0&id=32b8eb32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b8eb32",
  null
  
)

export default component.exports